import { useAuth } from 'contexts/auth';
import InstructorAssignmentsPage from 'pages/InstructorAssignments';
import StudentAssignmentsPage from 'pages/StudentAssignments';

const AssignmentsPage = () => {
    const { auth } = useAuth();
    if (auth.role === 'instructor') return <InstructorAssignmentsPage />;
    if (auth.role === 'ta') return <InstructorAssignmentsPage />;
    if (auth.role === 'student') return <StudentAssignmentsPage />;
    return null;
};

export default AssignmentsPage;
